import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useMessage } from '@tmapy/intl';

import { BtnBar, Form, FormItem, SecondaryBtn, CtaBtn, Textarea } from '@tmapy/style-guide';

import { useInput } from '../../hooks';
import { InputProps } from '../../hooks/useInput';
import { orderApprovalMessages as msg } from './orderMessages';

type ApprovalDialogProps = {
  confirmApproved: Function;
  closeApprovalDialog: Function;
};

export const ApprovalDialog: React.FC<ApprovalDialogProps> = (props) => {
  const formatMessage = useMessage();

  const handleApproveFormConfirm = () => {
    props.confirmApproved(approveReason.value);
  };

  const handleDialogClose = () => {
    props.closeApprovalDialog();
  };

  const approveReason = useInput<InputProps>({
    name: 'approval_reason',
    initialValue: '',
    label: formatMessage(msg.orderApprovalReason),
  });

  return (
    <Form onSubmit={handleApproveFormConfirm}>
      <div className='sg-a-p-4 sg-u-vs-2'>
        <FormItem {...approveReason}>
          <Textarea {...approveReason} />
        </FormItem>

        <BtnBar>
          <CtaBtn type='submit'>
            <FormattedMessage {...msg.orderApproveBtn} />
          </CtaBtn>
          <SecondaryBtn isDanger onClick={handleDialogClose}>
            <FormattedMessage {...msg.orderApprovalCloseDialogBtn} />
          </SecondaryBtn>
        </BtnBar>
      </div>
    </Form>
  );
};
